// Compact language switch for the public pages (marketing Homepage +
// LoginPage). Pre-login there's no `users.locale` to write —
// `i18n.changeLanguage` re-renders the page and i18next's detector caches
// the choice to localStorage, so it survives reload. The in-app picker
// (Settings → Account) is the authenticated equivalent that also persists
// to the server.

import { useTranslation } from 'react-i18next'
import type { Locale } from '../i18n'

const LOCALES: ReadonlyArray<readonly [Locale, string, string]> = [
  ['en', 'EN', 'Switch to English'],
  ['zh', '中', '切换到中文'],
  ['ja', '日', '日本語に切り替え'],
  ['de', 'DE', 'Auf Deutsch umschalten'],
  ['fr', 'FR', 'Passer en français'],
  ['zhtw', '繁', '切換到繁體中文'],
  ['es', 'ES', 'Cambiar a español'],
  ['ko', '한', '한국어로 전환'],
  ['it', 'IT', 'Passa all’italiano'],
]

export function LanguageToggle() {
  const { i18n } = useTranslation()
  const base = i18n.language?.toLowerCase().split('-')[0]
  const current: Locale =
    (LOCALES.find(([code]) => code === base)?.[0]) ?? 'en'
  return (
    <div
      className="mono"
      style={{
        display: 'inline-flex',
        border: '1px solid var(--rule)',
        borderRadius: 4,
        overflow: 'hidden',
      }}
    >
      {LOCALES.map(([lng, label, aria]) => {
        const active = current === lng
        return (
          <button
            key={lng}
            type="button"
            aria-label={aria}
            onClick={() => {
              if (!active) void i18n.changeLanguage(lng)
            }}
            style={{
              fontSize: 11,
              padding: '3px 9px',
              border: 'none',
              background: active ? 'var(--ink-1)' : 'transparent',
              color: active ? 'white' : 'var(--ink-3)',
              fontWeight: active ? 600 : 400,
              cursor: active ? 'default' : 'pointer',
            }}
          >
            {label}
          </button>
        )
      })}
    </div>
  )
}
